module.exports = __webpack_public_path__ + "img/ht.64c05f52.svg";